import {
  Router,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthGuardService {
  constructor(
    public auth: AuthService,
    public route: ActivatedRoute,
    public router: Router
  ) {}

  checkLogin(roles: Array<string>): boolean | Observable<boolean> | Promise<boolean> {
    return this.auth.getNewToken().pipe(
      map((token) => {
        if (!token) {
          this.auth.forceLogin();
          return false;
        }
        if (roles && roles.length && !this.auth.hasAnyRole(roles)) {
          // role not authorised so redirect to home page
          this.router.navigate(['/']);
          return false;
        }
        return true;
      })
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.checkLogin(route.data.roles);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }

  canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
    let roles = route.data ? route.data.roles : new Array<string>();
    return this.checkLogin(roles);
  }
}
